<template>
  <div :class="isWin ? 'win-bars' : 'mac-bars'">
    <template v-if="isWin">
      <div class="min-size" @click="minSizeWin"></div>
      <div class="max-size" @click="maxSizeWin"></div>
      <div class="close-btn" @click="closeWin"></div>
    </template>
    <template v-else>
      <div class="bars close" @click="closeWin"></div>
      <div class="bars min" @click="minSizeWin"></div>
      <div class="bars max" @click="maxSizeWin"></div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    beforeClose: {
      type: Function,
      default: null,
    },
  },
  data: function () {
    return {
      isWin: window.isWin(),
    };
  },
  methods: {
    closeWin() {
      if (this.beforeClose) {
        this.beforeClose();
      } else {
        window.ReplyElectronApi.closeWin();
      }
    },
    minSizeWin() {
      window.ReplyElectronApi.minSizeWin();
    },
    maxSizeWin() {
      window.ReplyElectronApi.maxSizeWin();
    },
  },
};
</script>

<style lang="scss" scoped>
.win-bars {
  display: inline-block;
  pointer-events: none;
  box-sizing: content-box;
  width: 100px;
  height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-app-region: none;
  pointer-events: auto;
  .min-size,
  .max-size,
  .close-btn {
    cursor: pointer;
    width: 30px;
    height: 30px;
    background-size: 30px 30px;
    background-position: center;
    -webkit-app-region: none;
    // margin-right: 24px;
    pointer-events: auto;
  }

  .min-size {
    background-image: url("../../../assets/images/electron/min-icon.png");
  }
  .max-size {
    background-image: url("../../../assets/images/electron/max-icon.png");
  }
  .close-btn {
    background-image: url("../../../assets/images/electron/close-icon.png");
  }
}
.mac-bars {
  display: inline-block;
  pointer-events: none;
  box-sizing: content-box;
  width: 82px;
  height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  -webkit-app-region: none;
  pointer-events: auto;

  .bars {
    width: 18px;
    height: 18px;
    background-size: 18px 18px;
    background-position: center;
    cursor: pointer;
    border-radius: 50%;
  }
  .close {
    background-color: #ff6057;
  }
  .min {
    background-color: #fdbc2e;
  }
  .max {
    background-color: #27c840;
  }

  &:hover {
    .close {
      background-image: url("../../../assets/images/electron/close_hover.png");
    }
    .min {
      background-image: url("../../../assets/images/electron/min_hover.png");
    }
    .max {
      background-image: url("../../../assets/images/electron/max_hover.png");
    }
  }
}
</style>
